var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdokladkeepStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.991 42.52H6.529A6.529 6.529 0 010 35.991V6.529A6.529 6.529 0 016.529 0h29.463a6.529 6.529 0 016.529 6.529v29.463a6.53 6.53 0 01-6.53 6.528z",
    fill: "#9E237C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.522 27.937h5.279v5.243h-5.279z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.209 16.501a10.376 10.376 0 00-2.398-3.685c-1.073-1.073-2.403-1.92-3.991-2.543-1.588-.622-3.444-.933-5.568-.933h-5.891c-.966 0-1.679.252-2.14.756-.462.504-.692 1.154-.692 1.947v13.339h5.279V14.297h3.702c1.116 0 2.113.15 2.993.451.88.301 1.625.751 2.237 1.352a6.128 6.128 0 011.416 2.189c.332.858.499 1.835.499 2.929a8.39 8.39 0 01-.276 2.195c-.041.13-.085.26-.133.386a6.275 6.275 0 01-1.416 2.221c-.612.612-1.357 1.084-2.237 1.416-.88.333-1.878.499-2.993.499h-1.203v5.224h.856c2.124 0 3.98-.327 5.568-.982 1.588-.654 2.918-1.539 3.991-2.656 1.073-1.115 1.872-2.36 2.398-3.734.526-1.373.789-2.779.789-4.217v-.708a12.195 12.195 0 00-.79-4.361z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdokladkeepStyle);
export default __webpack_public_path__ + "static/media/idoklad.keepStyle.26245e93f65e9efe892af3e7cd38a2e1.svg";
export { ForwardRef as ReactComponent };